import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {ConfirmDialogProps} from '../../../../entity/props/widget/confirm-dialog-props';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import {observer} from 'mobx-react-lite';

import '../../../../assets/css/style.css';

const ConfirmDialog = (props: ConfirmDialogProps): JSX.Element => {

  return (
    <Dialog open={props.open}>
      <DialogTitle className={'zitles-dialog-title'}>
        <span>{props.title}</span>
        <IconButton id={'btn-confirm-close'} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => props.handleCancel ? props.handleCancel(event) : props.setOpen(false)}>
          <CloseIcon className={'dialog-icon'}/>
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={'zitles-confirm-dialog-content'}>
        <span>{props.message}</span>
      </DialogContent>
      <DialogActions className={'action-btn-container'}>
        <Button
          id={'btn-confirm-cancel'}
          disableTouchRipple
          onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => props.handleCancel ? props.handleCancel(event) : props.setOpen(false)}
          className={'zitles-button cancel'}>
          Cancel
        </Button>
        <Button
          id={'btn-confirm-delete'}
          disabled={props.loading}
          className={`zitles-button confirm submit ${props.loading ? 'disable' : ''}`}
          onClick={props.handleSubmit}
          startIcon={props.loading ? <CircularProgress size={14} color='inherit' /> : null}>
          {
            props.loading ? props.submitText ?? 'Deleting' : props.title
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default observer(ConfirmDialog);
